export function userAgentMatch(regex: RegExp): boolean {
  return navigator.userAgent.match(regex) !== null;
}
